import { createSupabaseClient } from '@hotel/shared'
import type { Database } from '../../types/supabase'
import { SUPABASE_CONFIG } from '../../config/supabase'
import { logger } from '../logger'

// Lazy initialization function for Supabase client.
// Builds the client via the shared, platform-agnostic factory (web injects its
// own Vite env via SUPABASE_CONFIG). This prevents the app from crashing at
// module-load if variables are missing.
function getSupabaseClient() {
  if (!SUPABASE_CONFIG.url || !SUPABASE_CONFIG.anonKey) {
    console.error('Supabase configuration is missing. App will likely fail.')
    // Return a dummy client so we don't throw at module level.
    return createSupabaseClient<Database>({
      url: 'https://placeholder.supabase.co',
      anonKey: 'placeholder',
      persistSession: false,
    })
  }

  return createSupabaseClient<Database>({
    url: SUPABASE_CONFIG.url,
    anonKey: SUPABASE_CONFIG.anonKey,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  })
}

export const supabase = getSupabaseClient()

if (typeof window !== 'undefined') {
  const isDev = import.meta.env.DEV || window.location.hostname === 'localhost'
  if (isDev && SUPABASE_CONFIG.url) {
    logger.debug('Supabase client initialized', { url: SUPABASE_CONFIG.url })
  }
}
